import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';

function ProductTagListTemplate({ productTagListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization
    } = productTagListViewStore;
    return (
        <ApplicationListLayout store={productTagListViewStore}>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} />
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='PRODUCT_TAG.LIST.EMPTY_STATE.TITLE' description='PRODUCT_TAG.LIST.EMPTY_STATE.DESCRIPTION' />
}

ProductTagListTemplate.propTypes = {
    productTagListViewStore: PropTypes.object
};

export default defaultTemplate(ProductTagListTemplate);
